var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1C1C1A",
  fillRule: "evenodd",
  d: "M8 0a.5.5 0 0 0-.5.5v7h-7a.5.5 0 0 0 0 1h7v7a.5.5 0 0 0 1 0v-7h7a.5.5 0 0 0 0-1h-7v-7A.5.5 0 0 0 8 0",
  clipRule: "evenodd"
})));
export { SvgPlus as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04IDBDNy43MjM4NiAwIDcuNSAwLjIyMzg1OCA3LjUgMC41VjcuNUgwLjVDMC4yMjM4NTggNy41IDAgNy43MjM4NiAwIDhDMCA4LjI3NjE0IDAuMjIzODU4IDguNSAwLjUgOC41SDcuNVYxNS41QzcuNSAxNS43NzYxIDcuNzIzODYgMTYgOCAxNkM4LjI3NjE0IDE2IDguNSAxNS43NzYxIDguNSAxNS41VjguNUgxNS41QzE1Ljc3NjEgOC41IDE2IDguMjc2MTQgMTYgOEMxNiA3LjcyMzg2IDE1Ljc3NjEgNy41IDE1LjUgNy41SDguNVYwLjVDOC41IDAuMjIzODU4IDguMjc2MTQgMCA4IDBaIiBmaWxsPSIjMUMxQzFBIi8+Cjwvc3ZnPgo=";